import React, { useEffect, useState } from "react";

export default function PortalLogo({ src, className = "h-16 object-contain" , style     }) {
  const [logoSrc, setLogoSrc] = useState(  "assets/images/auth/logo.png");

  useEffect(() => {
    try {
      const storedLogo = localStorage.getItem("portal_logo_url");
      const colorPrimario = localStorage.getItem("color_primario");
      const colorFondo = localStorage.getItem("color_fondo");
      console.log("portal_logo_url en localStorage:", storedLogo);

      if (storedLogo && storedLogo.trim() !== "") {
        setLogoSrc(storedLogo);
      }

       // Asegúrate que vengan como #RRGGBB o colores válidos CSS
          if (colorPrimario) {
            document.documentElement.style.setProperty( "--primary-600",  colorPrimario  );
            document.documentElement.style.setProperty(  "--primary-700",  colorPrimario  );
            document.documentElement.style.setProperty( "--primary-50",  colorPrimario  );
          }

          if (colorFondo) {
            document.documentElement.style.setProperty( "--neutral-50", colorFondo );
          }


    } catch (e) {
      console.error("Error leyendo portal_logo_url:", e);
    }
  }, []);

  return (
    <img
      src={logoSrc}
      alt="Portal Trabajador Comondú"
      className={className}
      style={style}
      onError={() => {
        // Si la imagen de localStorage falla, regresa al logo default
        setLogoSrc("assets/images/auth/logo.png");
      }}
    />
  );
}